import { Button, DialogContent, Typography } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';

import styles from './WelcomeDialog.module.scss';

export interface WelcomeDialogProps extends DialogProps {
  onConfirm: () => void;
}

export function WelcomeDialog({ onConfirm, ...rest }: WelcomeDialogProps) {
  return (
    <Dialog {...rest} className={styles.dialog}>
      <DialogContent>
        <Typography component='h4' variant='h4'>
          Fantastic! {'\u{1F389}'}
        </Typography>

        <Typography component='p' variant='body2'>
          Your virtual waiting room is now <strong>live</strong>!
        </Typography>

        <Typography component='p' variant='body2'>
          <strong>Invite a client</strong> and <strong>start your first session</strong> now!
        </Typography>

        <Button variant='contained' onClick={onConfirm} className={styles.formButton}>
          Get started
        </Button>
      </DialogContent>
    </Dialog>
  );
}
